import React from 'react'
import { Document, Image, Page } from '@react-pdf/renderer'
import { renderToStaticMarkup } from 'react-dom/server'
import Html from 'react-pdf-html'
import CCLogo from '../../../Images/Branding/cc-combination-blue.png'
import { CommunityFamiliesReportRow } from '../../../swagger'
import FamiliesPDF from './FamiliesPDF'
import { styles } from './styles'

const FamiliesReportPDF: React.FC<{
  rows: CommunityFamiliesReportRow[]
  communityName?: string
}> = ({ rows, communityName }) => {
  return (
    <Document title="Families">
      <Page size="LETTER" style={styles.page} orientation="landscape">
        <Image style={styles.logo} src={CCLogo} />
        <Html>
          {renderToStaticMarkup(
            <FamiliesPDF rows={rows} communityName={communityName} />
          )}
        </Html>
      </Page>
    </Document>
  )
}

export default FamiliesReportPDF
